module.exports = "build/fonts/tableaubanner.png";